import { useLocation } from "react-router";
import { gsap } from "gsap";
import { useEffect, useRef } from "react";

export default function PageTransition({ children }) {
  const location = useLocation();
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;

    // Initial state
    gsap.set(el, { opacity: 0, y: 40 });

    // Enter animation
    gsap.to(el, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out",
    });

    return () => {
      // Exit animation
      gsap.to(el, {
        opacity: 0,
        y: -40,
        duration: 0.4,
        ease: "power2.in",
      });
    };
  }, [location.pathname]);

  return <div ref={containerRef}>{children}</div>;
}
